import { render, staticRenderFns } from "./apply-data.vue?vue&type=template&id=5b2ad204&scoped=true&"
import script from "./apply-data.vue?vue&type=script&lang=js&"
export * from "./apply-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ad204",
  null
  
)

export default component.exports